
<script>
    export default {
        methods: {
            $can(permissionName) {
                var permisos=JSON.parse(localStorage.getItem('permissions'));
                return permisos.indexOf(permissionName)!== -1;
            },


    }
}
</script>

